export const firebaseConfig = {
    apiKey: "AIzaSyDDZpuW_FBwD9i4mj6aX9RDn5uMVIz71D0",
    authDomain: "ar-invitation.firebaseapp.com",
    databaseURL: "https://ar-invitation.firebaseio.com",
    projectId: "ar-invitation",
    storageBucket: "ar-invitation.appspot.com",
    messagingSenderId: "921536082914",
    appId: "1:921536082914:web:f1a9eede2ae99a7722bfbb"
}